<template>
    <app-layout title="Dashboard">
        <div class="pt-8 px-8">
            <div class="flex gap-x-4">
                <!-- <div class="flex flex-1">
                    <div>
                        <h2>Recent Orders</h2>


                    </div>
                </div> -->

                <div class="flex flex-1 flex-col">
                    <div class="flex flex-1 justify-between">
                        <h2>Announcements</h2>
                        <jet-button type="button" :href="route('announcements.index')">Manage</jet-button>
                    </div>

                     <ol class="pt-4 pl-4 list-decimal">
                        <announcement
                            v-for="(announcement) in announcements"
                            :key="announcement.id"
                            :announcement="announcement"
                            class="mb-6"
                        />
                    </ol>

                    <div v-show="!announcements.length" class="pt-4">
                        No current announcements.
                    </div>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout.vue'
    import JetButton from '@/Jetstream/Button';
    import Announcement from '@/Shared/Announcement.vue';

    export default {
        components: {
            AppLayout,
            JetButton,
            Announcement,
        },

        props:['announcements'],
    }
</script>
